// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import echarts from 'echarts'
import moment from 'moment'
import VueDND from 'awe-dnd'
import Vddl from 'vddl';
import 'element-ui/lib/theme-chalk/index.css'
// import 'font-awesome/css/font-awesome.min.css'
import '@/styles/index'
import '@/styles/theme'
import '@/assets/iconfont/iconfont.css'
import '../static/UE/ueditor.config.js'
import '../static/UE/ueditor.all.min.js'
import '../static/UE/lang/zh-cn/zh-cn.js'
import '../static/UE/ueditor.parse.min.js'
import VideoPlayer from 'vue-video-player'
import toTop from '@/components/toTop'
import htmlToPdf from '@/utils/htmlToPdf.js'
import { apiOldResDeal } from '@/utils/request'
htmlToPdf.install(Vue)
Vue.use(VideoPlayer);
Vue.use(ElementUI)
Vue.use(Vddl);		//拖拽组件-插入
Vue.use(VueDND)//拖拽排序组件-交换
/*公共组件*/
Vue.component('to-top',toTop)

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment
Vue.prototype.$apiOldResDeal = apiOldResDeal

Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});


new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js